import { create } from "zustand";
import { api } from "../services/api";
import { DurationOption } from "./chatStore";

export interface Contact {
  id: string | undefined;
  userName: string;
  name: string;
  lastSeen?: string | null;
  status?: string;
  commonGroups?: string[];
  isGroup: boolean;
  access_token?: string | null;
  messageDuration?: number | null;
  blocked?: boolean;
  counter?: number;
  created_at?: string;
  hardPassword?: string;
  password_hash?: string;
  publicKey?: string | null;
  role?: string;
  updated_at?: string;
  isOnline?: boolean;
  contactId?: string;
  graphicAccountId?: string;
  graphicAccount?: {
    id: string | undefined;
    userName: string;
    name: string;
    lastSeen?: string | null;
    status?: string;
    access_token?: string | null;
    blocked?: boolean;
    counter?: number;
    created_at?: string;
    hardPassword?: string;
    password_hash?: string;
    publicKey?: string | null;
    role?: string;
    updated_at?: string;
    isOnline?: boolean;
  };
  contact?: {
    id: string | undefined;
    userName: string;
    name: string;
    lastSeen?: string | null;
    status?: string;
    access_token?: string | null;
    blocked?: boolean;
    counter?: number;
    created_at?: string;
    hardPassword?: string;
    password_hash?: string;
    publicKey?: string | null;
    role?: string;
    updated_at?: string;
    isOnline?: boolean;
  };
}

interface ContactStore {
  contacts: Contact[];
  setContacts: (contacts: Contact[]) => void;
  getContacts: () => Contact[];
  listContactsByUserId: (userId: string) => Promise<void>;
  deleteContact: (id: string) => Promise<void>;
}

export const useContactStore = create<ContactStore>((set, get) => ({
  contacts: [],

  setContacts: (contacts: Contact[]) => {
    set({ contacts });
  },

  getContacts: () => {
    return get().contacts;
  },

  listContactsByUserId: async (userId: string) => {
    try {
      console.log("[ContactStore] Buscando contatos para userId:", userId);
      const res = await api.get<{ contacts: Contact[] }>(`/contacts/${userId}`);
      console.log("[ContactStore] Resposta da API:", res.data);
      set({ contacts: res.data.contacts });
      console.log("[ContactStore] Contatos definidos na store:", res.data.contacts?.length || 0);
    } catch (error: any) {
      console.error("[ContactStore] Erro ao buscar contatos (dados anteriores preservados):", error);
      console.error("[ContactStore] Detalhes do erro:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        url: error.config?.url,
      });
      // NÃO limpa os contatos em caso de erro de rede ou API.
      // Mantém os dados existentes para o usuário não perder a lista.
    }
  },

  deleteContact: async (id: string) => {
    await api.delete(`/contacts/${id}`);

    set((state) => ({
      contacts: state.contacts.filter((c) => c.id !== id),
    }));
  },
}));
